import type { EntityHeaderConfig } from '@pesto/features/src/EntityProfile/types/EntityHeader.types';
import type { ReactNode } from 'react';

import { Landmark, Layers } from 'lucide-react';

import type { LoanDetailViewModel } from './toLoanDetail';

import { LoanStatus } from '../../__generated__/graphql/api';

const buildTitle = (loan: LoanDetailViewModel): string => {
  return loan.partnerAccountNumber ? `Loan · ${loan.partnerAccountNumber}` : 'Loan';
};

interface BuildLoanHeaderConfigParams {
  loan: LoanDetailViewModel;
  actions?: ReactNode;
}

export const buildLoanHeaderConfig = ({ loan, actions }: BuildLoanHeaderConfigParams): EntityHeaderConfig => {
  const badges: EntityHeaderConfig['badges'] = [];

  if (loan.isDelinquent || loan.status === LoanStatus.Delinquent) {
    badges.push({ label: 'Delinquent', variant: 'outline' });
  }

  if (loan.status === LoanStatus.Closed) {
    badges.push({ label: 'Closed', variant: 'outline' });
  }

  if (loan.promoEndDate) {
    badges.push({ label: 'Promo', variant: 'outline' });
  }

  return {
    avatar: { icon: Landmark },
    title: buildTitle(loan),
    secondary: { label: 'Loan ID', value: loan.id, mono: true },
    meta: loan.programName ? [{ icon: Layers, value: loan.programName }] : [],
    badges,
    actions,
  };
};
